import React from 'react'
import { useQuery } from '@apollo/client'

import { ContentLoaderTableOnly } from '../../../components/loader/loader.component'
import TableComponent from '../../../components/table/table.component'
import LabelComponent from '../../../components/label/label.component'
import LinkComponent from '../../../components/link/link.component'

import { ActionContainer, SortingContainer } from '../admin.styles'

import { GET_CASH_ACCOUNT_LIST } from '../../../config/graphql'
import { authHeaders } from '../../../utils/api-auth'

const CashAccountList = ({ dateRange, groupFilter }) => {
  console.log({ variables: { ...dateRange, ...groupFilter } })
  const { loading, data } = useQuery(GET_CASH_ACCOUNT_LIST, { variables: { ...dateRange, ...groupFilter } });
  console.log(data);
  const dataCashAccount = data?.cashAccounts || [];
  console.log(dataCashAccount);

  if (loading && !dataCashAccount.length) {
    return <ContentLoaderTableOnly />
  } else {
    var idx = 0;
    let currency = Intl.NumberFormat('id', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return <div>
      <TableComponent mode='custom' template='1fr 4fr 3fr 3fr 3fr 10fr'>
        <div aria-label='head'>
          <div>
            <SortingContainer>No</SortingContainer>
          </div>
          <div>
            <SortingContainer>Nama</SortingContainer>
          </div>
          <div>
            <SortingContainer>Murid/Staff</SortingContainer>
          </div>
          <div>
            <SortingContainer>Kelas</SortingContainer>
          </div>
          <div>
            <SortingContainer>Saldo</SortingContainer>
          </div>
          <div>
            <SortingContainer>Status Kartu</SortingContainer>
          </div>
        </div>
        <div aria-label='body'>
          {dataCashAccount.map((cashAccount) => {
            idx++;
            var paymentAvailable = cashAccount.user.identifications.find((id) => id.kind == 'payment')
            return (
              <div key={idx}>
                <div>
                  <LabelComponent mode='tagredmobile'>NO</LabelComponent>
                  {idx}
                </div>
                <div>
                  <LabelComponent mode='tagredmobile'>Nama</LabelComponent>
                  {(cashAccount.user.name)}
                </div>
                <div>
                  <LabelComponent mode='tagredmobile'>Murid/Staff</LabelComponent>
                  {cashAccount.user.kind == 'guru' ? 'Staff' : 'Murid'}
                </div>
                <div>
                  <LabelComponent mode='tagredmobile'>Kelas</LabelComponent>
                  {(cashAccount.user.classroom ? cashAccount.user.classroom.name : null)}
                </div>
                <div>
                  <LabelComponent mode='tagredmobile'>Saldo</LabelComponent>
                  {(currency.format(cashAccount.balance))}
                </div>
                <div>
                  <LabelComponent mode='tagredmobile'>Status Kartu</LabelComponent>
                  {paymentAvailable ? (
                    <div>
                      Aktif
                      &nbsp;
                      <LinkComponent style={{ lineHeight: '2em' }} to='#' mode='clearlink' onClick={() => {
                        var xhr = new XMLHttpRequest();
                        xhr.open("DELETE", 'https://genios-api.genios.id/cash_account', true);
                        xhr.setRequestHeader('Content-Type', 'application/json');
                        Object.entries(authHeaders()).forEach(([name, value]) => xhr.setRequestHeader(name, value));
                        xhr.onreadystatechange = function () {
                          if (this.readyState != 4) return;

                          if (this.status == 200) {
                            var data = JSON.parse(this.responseText);

                            console.log(data);
                            // we get the returned data
                          }
                          window.location.reload(false);

                          // end of state change: it can be after some time (async)
                        };

                        xhr.send(JSON.stringify({
                          "user_id": cashAccount.user.id,
                          "admin_id": 233,
                        }));
                      }
                      }>Reset</LinkComponent>
                    </div>
                  ) : (
                    <div>
                      Tidak Aktif
                    </div>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </TableComponent>
    </div>
  }
}

export default CashAccountList;